export enum PersonandOrganizationType {
    Student = 'student'
}